<template>
  <div>
    <div v-for="(item, i) in items" :key="i">
      <NotiCardItem :item="item" @onAccept="onAccept" />
    </div>
  </div>
</template>

<script>
import NotiCardItem from "./NotiCardItem.vue";
export default {
  components: { NotiCardItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    onAccept: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    items: function () {
      this.$forceUpdate();
    },
  },
};
</script>

<style></style>
